import { useLocation } from "react-router-dom";

const useLocationHook = () => {
  const { pathname } = useLocation();

  return {
    isLivePage: pathname.includes("/orders/live"),
    isPosOrderPage: pathname.includes("/orders/pos-order"),
    // Exact match: other urls may contain "/waiter" too (e.g. /menu/waiter)
    isWaiterPage: pathname === "/waiter" || pathname.startsWith("/waiter/"),
    isOrderDetailPage: pathname.includes("/order/"),
    isUsersPage: pathname.includes("/users"),
    isUserDetailPage:
      !pathname.includes("/users") && pathname.includes("/user"),
    isUserOrdersPage:
      pathname.includes("/user/") && pathname.includes("/orders"),
    isVersionDetailPage: pathname.includes("/version/"),
    isReceiptDetailPage: pathname.includes("/receipt/"),
    isReviewDetailPage: pathname.includes("/review/"),
    // The "scheduled" tab is an overview, not a detail page
    isPushDetailPage:
      pathname.includes("/marketing/push/") &&
      pathname !== "/marketing/push/scheduled",
    isNewsletterDetailPage:
      pathname.includes("/marketing/newsletter/") &&
      pathname !== "/marketing/newsletter/scheduled",
    isDiscountDetailPage: pathname.includes("/korting/"),
    // Only a theme detail; /websitesettings/<section> are overview pages
    isWebsiteSettingsDetail: pathname.startsWith("/websitesettings/themes/"),
    isZipcodeDetail: pathname.includes("/zipcodes/"),
    isTermsCondition: pathname.includes("/terms"),
    isLoyaltyEditPage: pathname.includes("/loyalty/edit"),
  };
};

export default useLocationHook;
